module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/normal.9a3bce3b.png";